import { alpha, Box, Breadcrumbs, styled, Typography } from '@mui/material';
import { ElementType } from 'react';

export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  minWidth: 0,
  '& .MuiBreadcrumbs-ol': {
    flexWrap: 'nowrap',
  },
  '& .MuiBreadcrumbs-separator': {
    flexShrink: 0,
    color: theme.palette.text.disabled,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  '& .MuiBreadcrumbs-li': {
    minWidth: 0,
    flexShrink: 3,
    overflow: 'hidden',
    '&:first-of-type': {
      flexShrink: 0,
    },
    '&:last-of-type': {
      flexShrink: 1,
    },
    '& > a': {
      display: 'block',
      overflow: 'hidden',
    },
  },
  '& .MuiButtonBase-root': {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.text.secondary,
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      color: theme.palette.text.primary,
    },
  },
}));

export const BreadcrumbsHome = styled(Box)<{ component?: ElementType }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  transition: theme.transitions.create('color'),
  '&:hover': { color: theme.palette.text.primary },
}));

export const BreadcrumbLink = styled(Typography)<{ component?: ElementType }>(({ theme }) => ({
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.9375rem',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  transition: theme.transitions.create('color'),
  '&:hover': { color: theme.palette.text.primary, textDecoration: 'underline' },
}));

export const BreadcrumbCurrent = styled(Typography)(() => ({
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.9375rem',
  fontWeight: 700,
}));
